import Button from './Button';
import Checkbox from '@mui/material/Checkbox';
import CloseIcon from '@mui/icons-material/Close';
import Dialog from '@mui/material/Dialog';
import MuiDialogContent from '@mui/material/DialogContent';
import { COLORS, FONTS, FONT_WEIGHT } from '../common/theme';
import { makeStyles, createStyles, StyleRules } from '@mui/styles';
import {
  useTranslations,
  useDynamicTranslations,
} from '../common/hooks/useTranslations';

const useStyles = makeStyles(
  (theme): StyleRules =>
    createStyles({
      closeButtonStyle: {
        position: 'absolute',
        right: 20, // theme.spacing(2),
        top: 20, // theme.spacing(2),
        fill: COLORS.textGray,
        width: '40px',
        height: '40px',
        pointerEvents: 'auto',
        zIndex: 100,
        cursor: 'pointer',
        '@media (hover: hover) and (pointer: fine)': {
          '&:hover': {
            opacity: 0.7,
            transition: '0.5s ease',
          },
        },
      },
      dialogContentStyle: {
        display: 'flex',
        flexDirection: 'column',
        margin: '16px',
        color: COLORS.textBlack,
        padding: '30px',
        fontWeight: FONT_WEIGHT.medium,
        fontSize: '16px',
        lineHeight: '22px',
        fontFamily: FONTS.alegreya,
        alignItems: 'center',
      },
      publicStyle: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'center',
        margin: '20px 0 10px 0',
      },
      sendButtonStyle: {
        width: '190px',
      },
    })
);

const SurveyFormPublicDialog = ({
  onClose,
  onCheckboxChange,
  isPublicChecked,
  isProgress,
  isDialogOpen,
  onSend,
  lng,
}) => {
  const classes = useStyles();

  const isMobile = window.innerWidth < 900;

  const showPublicText = useDynamicTranslations('agreeshare', lng);
  const sendLabel = useDynamicTranslations('send', lng);
  const publicLabel = useDynamicTranslations('public', lng);

  const getPublicDialogText = () => {
    const label = { inputProps: { 'aria-label': publicLabel } };

    return (
      <>
        <div className={classes.publicStyle}>
          <Checkbox
            {...label}
            checked={isPublicChecked}
            onChange={onCheckboxChange}
          />
          <div className={classes.rulesTextStyle}>{showPublicText}</div>
        </div>
        <Button
          onClick={onSend}
          isProgress={isProgress}
          text={sendLabel}
          className={classes.sendButtonStyle}
          disabled={!isPublicChecked}
        />
      </>
    );
  };

  return (
    <Dialog
      fullScreen={isMobile}
      open={isDialogOpen}
      onClose={onClose}
      className={classes.dialogContainerStyle}
    >
      <CloseIcon className={classes.closeButtonStyle} onClick={onClose} />
      <MuiDialogContent className={classes.dialogContentStyle}>
        {getPublicDialogText()}
      </MuiDialogContent>
    </Dialog>
  );
};

export default SurveyFormPublicDialog;
